import {createReducer} from 'redux-act';
import {emptySalesPerHourGroup} from 'helpers/services/api/analyticsHelpers';
import {
  GET_SALES_PER_HOUR,
  GET_SALES_PER_HOUR_SUCCESS
} from 'store/analyticsSalesPerHour/action';

const initialState = () => ({
  // Independent groupings, each {series, hours, avgSales} (GROW-2476)
  perChannel: emptySalesPerHourGroup(),
  perFulfillment: emptySalesPerHourGroup(),
  salesPerHourLoading: false
});

const analyticsSalesPerHourReducer = createReducer(
  {
    [GET_SALES_PER_HOUR]: (state) => ({
      ...state,
      salesPerHourLoading: true
    }),
    [GET_SALES_PER_HOUR_SUCCESS]: (state, payload) => ({
      ...state,
      perChannel: payload.perChannel ?? emptySalesPerHourGroup(),
      perFulfillment: payload.perFulfillment ?? emptySalesPerHourGroup(),
      salesPerHourLoading: false
    })
  },
  initialState()
);

export default analyticsSalesPerHourReducer;
